import { MaskedInput } from "@swa-ui/core";

import { withFormField } from "../withFormField";

/**
 * MaskedInputFormField provides support for a standard MaskedInput component to be used in a Form.
 */

export const MaskedInputFormField = withFormField(MaskedInput);
